import { IconX } from "@tabler/icons-react";
import type { FC } from "react";
import { Button } from "react-aria-components";

export interface SearchModalCloseButtonProps {
  onClose?: () => void;
}

export const SearchModalCloseButton: FC<SearchModalCloseButtonProps> = (
  props,
) => {
  const { onClose } = props;

  return (
    <Button
      slot="close"
      aria-label="Close"
      className="flex size-8 shrink-0 items-center justify-center rounded-md text-foreground transition-colors hover:bg-muted focus-visible:bg-muted focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-ring data-[hovered]:bg-muted"
      onPress={onClose}
    >
      <IconX className="size-4" />
    </Button>
  );
};
